import React, { useEffect, useRef, useState } from 'react';
import { Editor, IAllProps } from '@tinymce/tinymce-react';
import { useField } from '@unform/core';

import { useModelo, IOptionsModelo } from '../../hooks/modelo';
import { htmlDecode, htmlEncode } from '../../utils/funcoes';

// import { Container } from './styles';

interface Props extends IAllProps {
  name: string;
  height: number;
}
interface IOptionsEditor {
  type: 'menuitem';
  text: string;
  onAction(): void;
}

const EditorTexto: React.FC<Props> = ({ name, height }) => {
  const {
    buscaOptionsModelo,
    optionsModelo,
    loading: loadingModelo,
  } = useModelo();
  const editorRef = useRef(null);
  const { fieldName, defaultValue, registerField } = useField(name);
  const [editorIsInitialized, setEditorIsInitialized] = useState(false);
  const [texto, setTexto] = useState('');

  useEffect(() => {
    setTexto(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (!optionsModelo) {
      buscaOptionsModelo({ ativo: 'true', tipo: '3' });
    }
  }, [buscaOptionsModelo, optionsModelo]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: editorRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  const modelo: IOptionsModelo[] | undefined = optionsModelo;

  return (
    <>
      <input
        className="d-none"
        value={texto}
        ref={editorRef}
        onChange={evt => setTexto(encodeURI(evt.target.value))}
      />
      {!loadingModelo && (
        <Editor
          tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
          onInit={() => {
            if (!editorIsInitialized) {
              setEditorIsInitialized(true);
            }
          }}
          initialValue={editorIsInitialized ? defaultValue : undefined}
          init={{
            height,
            text_patterns: false,
            menubar: false,
            font_size_formats:
              '8px 10px 11px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px 42px 48px 62px',
            font_size_input_default_unit: 'px',
            plugins: [
              'advlist autolink lists link image charmap print preview anchor',
              'searchreplace visualblocks code fullscreen',
              'insertdatetime media table paste code pagebreak',
            ],
            toolbar: [
              'undo redo | fontsize | bold italic underline alignleft aligncenter alignright alignjustify | forecolor backcolor | ',
              ' bullist numlist outdent indent | table | pagebreak code | myButton1 | menuButton ',
            ],
            content_style:
              'body { font-family:Helvetica,Arial,sans-serif; font-size: 14px; }',
            setup(editor) {
              editor.ui.registry.addMenuButton('menuButton', {
                text: 'Modelos',
                fetch(callback) {
                  if (modelo) {
                    const items: IOptionsEditor[] = modelo.map(model => ({
                      type: 'menuitem',
                      text: model.text,
                      onAction() {
                        editor.insertContent(htmlDecode(model.value));
                      },
                    }));
                    callback(items);
                  }
                },
              });
            },
          }}
          onEditorChange={(evt, ed) => setTexto(htmlEncode(ed.getContent()))}
        />
      )}
    </>
  );
};

export default EditorTexto;
